import ServiceApi from "../api/ServiceApi";

export default {
    namespaced: true,
    state:{
        service: {}
    },
    mutations:{
        setService(state, service) {
            state.service = service;
        }
    },
    actions: {
        serviceAllAction({commit}){
            ServiceApi.serviceAll()
                .then(res => {
                    commit('setService',res.data)
                })
        }
    }
}
